import React from "react";
import MarketingLocationPage from "./MarketingLocationPage";

export default function MarketingAgenturKaernten() {
  return <MarketingLocationPage locationKey="kaernten" />;
}
